import { Controller, Toolbar } from '@tencent/workbench';
import { FontSizeFeature } from './font-size-feature';
import { TOOLBAR_ITEMS, config } from './config';
import { wrapIdForInput } from '@framework/workbench/util/wrap-id-util';

/**
 * 工具栏 - 字号
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class FontSizeController {
    constructor(private readonly feature: FontSizeFeature) {
    }

    // 给ui绑定对应的计算属性
    @Toolbar(config.id, 'text')
    @Toolbar(wrapIdForInput(config.id), 'text')
    public getFontName() {
        return this.feature.getFontSizeName();
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForInput(config.id), 'dropdownContent')
    public renderSelectList() {
        return this.feature.renderSelectList();
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForInput(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}
